import React, { useMemo } from "react";
import { useFormik } from "formik";
import CustomSelect from "components/CustomSelect";
import { yupSchemaStep1 } from "schemas/yupSchema";
import judetePremier from "data/judetePremier";
import { goToTop } from "helpers/helpers";
import NavigateButtons from "components/NavigateButtons";
import { toast } from "react-toastify";
import { prepareDataGetOffers } from "helpers/PrepareData";
import { RequestMethod, requestJson } from "helpers/httpHelper";

export default function Step1({ currentStep, setCurrentStep, setLoading, stepsState, persistState, firstSubmit, setFirstSubmit }) {
   const formik = useFormik({
      enableReinitialize: true,
      initialValues: stepsState,
      validationSchema: yupSchemaStep1,
      validateOnChange: firstSubmit,
      validateOnBlur: false,
      onSubmit: values => {
         goToTop();
         saveDataAndShowOffers(values);
      },
   });

   const saveDataAndShowOffers = async values => {
      setLoading(true);
      const success = await getAllOffersForStep2(values);
      if (success.isSuccess) {
         persistState(prevState => {
            return {
               ...prevState,
               step1: {
                  ...prevState.step1,
                  judet: values.judet,
                  localitate: values.localitate,
                  codSIRUTA: values.codSIRUTA,
               },
               step2: {
                  ...prevState.step2,
                  oferte: success.response,
               },
               step6: {
                  ...prevState.step6,
                  consum: { ...prevState.step6.consum, judet: values.judet, localitate: values.localitate, codSIRUTA: values.codSIRUTA },
               },
            };
         });
         window.dataLayer.push({ event: "pas_1_casnici", info: { pagina: "step-1", finalizat: "da" } })
         setCurrentStep(currentStep + 1);
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
         setFirstSubmit(false);
      } else {
         toast.error("A aparut o eroare la afisarea ofertelor. Va rugam incercati din nou.");
      }

      setLoading(false);
   };

   // iau toate ofertele de gaz avabile in baza de date
   const getAllOffersForStep2 = async values => {
      const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS2, RequestMethod.POST, { data: prepareDataGetOffers(values) });

      if (response.isSuccess) {
         const oferteResponse = response.response.oferta;
         return { isSuccess: true, response: oferteResponse };
      } else {
         return { isSuccess: false, response: response.response };
      }
   };

   // filtrez judetele
   const judeteFiltrate = useMemo(
      () =>
         [...new Set(judetePremier
            .map(item => item.judetLong))]
            .sort()  // Sorts the array in ascending order
            .map(judetLong => {
               return { value: judetLong, label: judetLong };
         }),
      [judetePremier],
   );

   // filtrez localitatile in functie de judetul selectat
   const localitatiFiltrate = useMemo(() => {
      const localitati = judetePremier.filter(judet => judet.judetLong === formik.values.judet);
      return localitati.map(item => {
         return { value: item.localitate, label: item.localitate, codSIRUTA: item.codSIRUTA };
      }).sort((a, b) => a.label.localeCompare(b.label));  // Sorts based on the 'label' property
   }, [judetePremier, formik.values.judet]);

   const formSubmition = e => {
      e.preventDefault();
      setFirstSubmit(true);
      formik.handleSubmit();
   };

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <div className="pas-1">
                     <p>
                        ATENȚIE! Poți încheia un contract de furnizare numai dacă instalația ta de utilizare a gazelor naturale este funcțională și
                        poate fi alimentată cu gaze naturale. În cazul în care locul de consum nu este încă racordat la sistemul de distribuție și
                        dorești racordarea acestuia te rugăm accesează secțiunea{" "}
                        <a className="cursor-pointer color-green t-decoration" href="https://www1.premierenergy.ro/siteCerereRacordare2.html" target="_blank">
                           <strong>distribuție/racordare</strong>
                        </a>
                        .
                     </p>
                     <h2 className="first_title">Informații preliminare</h2>
                     <form onSubmit={e => formSubmition(e)}>
                        <div className="row row-input mt-50">
                           <div className="col-md-12">
                              <CustomSelect
                                 options={judeteFiltrate}
                                 value={formik.values.judet}
                                 onChange={value => {
                                    formik.setFieldValue("judet", value.value);
                                    formik.setFieldValue("localitate", "");
                                 }}
                                 placeholder="Alege județul..."
                                 id={"judet"}
                                 name={"judet"}
                                 labelDescription={"Județul locului de consum"}
                                 isError={formik.errors.judet && formik.touched.judet}
                              />
                              {formik.errors.judet && formik.touched.judet ? <div className="error-msg">{formik.errors.judet}</div> : null}
                           </div>

                           <div style={{ paddingTop: "30px" }} className="col-md-12 mt-50">
                              <CustomSelect
                                 options={localitatiFiltrate}
                                 value={formik.values.localitate}
                                 onChange={value => {
                                    formik.setFieldValue("localitate", value.value);
                                    formik.setFieldValue("codSIRUTA", value.codSIRUTA);
                                 }}
                                 placeholder="Alege localitatea..."
                                 id={"localitate"}
                                 name={"localitate"}
                                 labelDescription={"Localitatea locului de consum"}
                                 isError={formik.errors.localitate && formik.touched.localitate}
                              />
                              {formik.errors.localitate && formik.touched.localitate ? (
                                 <div className="error-msg">{formik.errors.localitate}</div>
                              ) : null}
                           </div>
                           <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} back={"displayNone"} />
                        </div>
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
